<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title>      
                <v-btn icon @click="gotoUsers">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                {{ 'Users' | translate }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row v-if="errors != 'Seats are full'">
                  <v-col cols="12" sm="8" md="8">
                    <v-alert
                      dense
                      v-for="(v, k) in errors"
                      :key="k"
                      outlined
                      type="error"
                    >{{ k }} {{ v }}</v-alert>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12" sm="8" md="8">
                    <v-alert dense outlined type="error">{{ errors }}</v-alert>
                  </v-col>
                </v-row>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row>
                        <v-col cols="12" sm="3">
                          <v-select
                            v-model="salutation"
                            :items="salutationvalues"
                            item-value="value"
                            item-text="name"
                            :label="'Salutation' | translate"
                            autocomplete="off"
                            name="salutation"
                            :rules="salutationRules"
                            outlined
                            required
                          ></v-select>
                        </v-col>
                        <v-col cols="9" sm="9">
                          <v-text-field
                            outlined
                            :label="'Name' | translate"
                            v-model="name"
                            name="name"
                            :rules="nameRules"
                            autocomplete="off"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            :label="'Email' | translate"
                            v-model="email"
                            name="email"
                            autocomplete="off"
                            :rules="emailRules"
                            type="email"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            :label="'Phone Number' | translate"
                            v-model="phone_no"
                            name="phone_no"
                            autocomplete="off"
                            :rules="numberRules"
                            type="number"
                            required
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="address"
                            v-model="address"
                            :rules="addressRules"
                            autocomplete="off"
                            :label="'Address' | translate"
                          ></v-textarea>
                        </v-col>
                      </v-row>

                      <v-row v-if="user_id !== null ">
                        <v-col cols="12" sm="12">
                          <div class="pb-4 title">{{ 'User Documents' | translate}}</div>
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>

                      <v-row v-if="user_id !== null ">
                        <v-col>
                        <v-data-table
                          :headers="personaldocumentheaders"
                          :items="personaldocuments"
                          :single-expand="singleExpand"
                          :expanded.sync="expanded"
                          item-key="perdoc_name"
                          show-expand
                          class="elevation-1"
                        >
                          <template v-slot:item.template ="{ item }" >
                              <v-btn small color="primary" v-on:click="downloadPersonal(item.doc_templates[0])">{{ 'View'| translate }}</v-btn>
                          </template>   
                          <template v-slot:item.update ="{ item }" >
                              <v-btn small color="primary" v-on:click="openDialog(item.doc_templates[0].doc_id, item.validity)" >{{ 'Update document'| translate }}</v-btn>
                          </template>                             
                          <template v-slot:top>
                            <v-toolbar flat>
                              <v-toolbar-title>{{ 'User Documents' | translate}}</v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                          </template>
                          <template v-slot:expanded-item="{ headers,item }">
                            <td :colspan="headers.length" style='padding: 0px !important;'>
                            <v-data-table
                              :headers="subdocumentheaders"
                              :items="item.user_documents"
                              item-key="perdoc_name"
                              class="elevation-1"
                              hide-default-footer
                            >
                            <template v-slot:item.view ="{ item }">
                                <v-btn small color="primary" v-on:click="downloadUser(item.ud_id, item.doc_id, item.extension)">{{ 'View'| translate }}</v-btn>
                            </template>  
                            <template v-slot:item.edit ="{ item }">
                                <v-btn small color="primary" v-on:click="openeditDialog(item.ud_id, item.doc_id,item.due_date)">{{ 'Edit'| translate }}</v-btn>
                            </template> 
                            </v-data-table> 
                            </td>                           
                          </template>
                        </v-data-table>                          
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
                <v-dialog v-model="dialog" persistent max-width="500">
                  <v-card>
                    <v-card-title class="headline" v-if='editDocument'>{{ 'Edit document' | translate }}</v-card-title>
                    <v-card-title class="headline" v-else>{{ 'Update document' | translate }}</v-card-title>
                    <v-card-text>
                        <v-card-text>
                          <v-container>
                            <v-form id="modelform" ref="modelform">
                              <v-row>

                                <v-col v-if="documenterrors" cols="12" sm="12" md="12">
                                  <v-alert
                                    dense
                                    v-for="(v, k) in documenterrors"
                                    :key="k"
                                    outlined
                                    type="error"
                                  >{{ k }} {{ v }}</v-alert>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" v-if='editDocument ==false'>
                                    <v-file-input
                                        id="document_file"
                                        name="file"
                                        outlined
                                        chips
                                        required
                                        label="Select file"
                                        @change="onFileSelected"
                                    ></v-file-input>
                                </v-col>

                                <v-col cols="12" sm="12">
                                  <v-autocomplete
                                      v-model="status"
                                      :items="statusvalues"
                                      item-value="value"
                                      item-text="text"
                                      :label="'Status' | translate"
                                      :rules="statusRules"
                                      outlined
                                      chips
                                      small-chips
                                      required
                                    ></v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    outlined
                                    :label="'Due date' | translate"
                                    v-model="due_date"
                                    name="due_date"
                                    type="date"
                                    :rules="dateRules"
                                    autocomplete="off"
                                    required
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12">
                                  <v-textarea
                                    outlined
                                    name="comment"
                                    v-model="comment"
                                    autocomplete="off"
                                    :label="'Comment (optional)' | translate"
                                  ></v-textarea>
                                </v-col> 

                              </v-row>

                            </v-form>
                          </v-container>
                        </v-card-text>                      
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-1" text @click="closeBox">{{ 'Close' | translate }}</v-btn>
                      <v-btn color="green darken-1" v-if="editDocument" text @click='editPersonalDocument'>{{ 'Update' | translate }}</v-btn>
                      <v-btn color="green darken-1" v-else text @click='uploadDocument'>{{ 'Upload' | translate }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>


                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="user_id != ''"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="user_id"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<style lang="scss">
.v-data-footer {
  -webkit-box-pack: start !important;
  -ms-flex-pack: start !important;
  justify-content: flex-start !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}

.v-application--is-ltr .v-data-footer__select {
  margin-left: 16px !important;
}
</style>

<script>
import {
  ADD_USER,
  FETCH_USERS,
  FETCH_GROUPS,
  FETCH_ROLES,
  RESET_STATE,
  FETCH_INDIVIDUAL_USER,
  DOWNLOAD_PERSONAL_DOCUMENT,
  DOWNLOAD_USER_DOCUMENT,
  UPDATE_USER_DOCUMENT,
  FETCH_PERSONAL_DOCUMENTS,
  UPDATE_USER
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING } from "@/store/mutations.type";
import store from "@/store";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
export default {
  name: "AddEditUser",
  beforeRouteEnter(to, from, next) {
    Promise.all([
      store.dispatch(RESET_STATE),
       store.dispatch(FETCH_USERS, ''),
      (store.getters.currentUser.roles.includes(1)?store.dispatch(FETCH_GROUPS, ''): ''),
      (store.getters.currentUser.roles.includes(1)?store.dispatch(FETCH_ROLES, ''):''),      
      (to.params.id ? store.dispatch(FETCH_INDIVIDUAL_USER, to.params.id) : ''),
      (to.params.id ? store.dispatch(FETCH_PERSONAL_DOCUMENTS, '?user_id='+to.params.id) : ''),
    ]).finally(() => {
      store.commit(SET_LOADING, false)
    });

    return next();
  },
  data: function() {
    return {
      name: "",
      email: "",
      address: "",
      phone_no: "",
      salutation: "",
      user_id: null,
      roles_id:[],
      doc_id: null,
      due_date: null,
      status: null,
      comment: null,
      personaldocumentid: null,
      file: null,
      group_admins: [],
      editDocument: false,
      expanded: [],
      dialog: false,
      singleExpand: false,
      groups_id:[],
      salutationvalues: [
        { value: "Mr", name: this.$t('Mr') },
        { value: "Ms", name: this.$t('Ms') },
        { value: "Mrs", name: this.$t('Mrs') }
      ],
      statusvalues: [
        { value: "active", text: this.$t("Active") },
        { value: "inactive", text: this.$t("Inactive") },
      ],            
      nameRules: [v => !!v || this.$t("Name is required")],
      emailRules: [v => /.+@.+/.test(v) || this.$t("Invalid Email address")],
      numberRules: [v => !!v || this.$t("Phone Number is required")],
      salutationRules: [v => !!v || this.$t("Salutation is required")],
      addressRules: [v => !!v || this.$t("Address is required")],
      rolesRules: [v => !!v || this.$t("Group admin is required")],
      groupsRules: [v => !!v || this.$t("Groups are required")],
      statusRules: [v => !!v || this.$t("Status is required")],
      dateRules: [v => !!v || this.$t("Date is required")],
    };
  },
  computed: {
    ...mapGetters(['individualuser', 'roles', 'groups', 'personaldocuments','currentUser']),
    ...mapState({
      errors: state => state.users.usererrors,
      documenterrors: state => state.documents.documenterrors
    }),
    personaldocumentheaders(){
      return  [
        { text: this.$t('Document name'), value: "perdoc_name" },
        {text: this.$t('Days until'), value: "validity"},
        {text: this.$t('Template'), value:'template'},
        {text: this.$t('Update'), value:'update'},
        { text: '', value: 'data-table-expand' },
      ]
    },
    subdocumentheaders(){
      return [
            { text: this.$t("Status"), value: "status" },       
            { text: this.$t("Due date"), value: "due_date" },  
            { text: this.$t("Uploaded by"), value: "uploaded_user" },  
            { text: this.$t("Uploaded on"), value: "updated_at" },
            { text: this.$t('Edit'), value: 'edit' },
            { text: this.$t('View'), value: 'view' },
          ]
    }
  },
  watch: {
    individualuser(value) {
      if(Object.keys(value).length>0){
        this.renderData()
      }
    }
  },
  created () {
    if(this.currentUser.roles.includes(1) ==false && this.currentUser.roles.includes(3)== false){
      this.$router.push('/learningcenter');
    }
  },
  methods: {
    gotoUsers() {
      this.$router.push({ name: "users" });
    },  
    onFileSelected() {
      this.file = document.getElementById("document_file").files[0];
    },      
    renderData() {
      this.name = this.individualuser.name;
      this.email = this.individualuser.email;
      this.phone_no = this.individualuser.phone_no;
      this.address = this.individualuser.address;
      this.salutation = this.individualuser.salutation;
      this.user_id = this.individualuser.user_id
    }, 
    async downloadPersonal(documentdata){
      await this.$store
        .dispatch(DOWNLOAD_PERSONAL_DOCUMENT, 'view-file/'+documentdata.docfile_id)
        .then(resp => {
          var fileURL = window.URL.createObjectURL(new Blob([resp]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', documentdata.doc_type+'.'+documentdata.extension);
          document.body.appendChild(fileLink);
          fileLink.click(); 
          store.commit(SET_LOADING, false);

        });
    },
    async downloadUser(id, name , extension){
      await this.$store
        .dispatch(DOWNLOAD_USER_DOCUMENT, 'view-file/'+id)
        .then(resp => {
          var fileURL = window.URL.createObjectURL(new Blob([resp]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', name+'.'+extension);
          document.body.appendChild(fileLink);
          fileLink.click(); 
          store.commit(SET_LOADING, false);

        });
    },
    openDialog(id, days){
      var currentDate = new Date()
      var validdate = new Date()
      validdate.setDate(currentDate.getDate()+days)
      this.dialog= true
      this.doc_id = id
      this.file=  null
      this.comment  = null
      this.due_date = validdate.toISOString().slice(0,10)
      this.status = null
      document.getElementById('document_file').value=''
    },
    openeditDialog(idpersonaldocument, docid, duedate){
      this.dialog= true
      this.doc_id = docid
      this.file=  null
      this.personaldocumentid = idpersonaldocument
      this.comment  = null
      this.due_date = duedate
      this.status = null
      this.editDocument = true
    },    
    closeBox(){
      document.getElementById("modelform").reset();
      this.dialog = false
      this.editDocument = false
    },
    async editPersonalDocument(){
      if (this.$refs.modelform.validate()) {
        if (this.file != null) {
          var formData = new FormData(document.getElementById("modelform"));
          formData.set("user_id", this.user_id)
          formData.set("doc_id", this.doc_id)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)
          formData.set('ud_id', this.personaldocumentid)
          formData.set('_method', 'put')
          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
              await store.dispatch(FETCH_PERSONAL_DOCUMENTS, '?user_id='+this.user_id).then( resp =>{
                if (resp !==undefined && resp.success) {
                  store.commit(SET_SNACKBAR, {status: true, message: 'Document updated successfully'})
                  this.dialog =false
                  this.doc_id = null
                  this.file=  ''
                  this.comment  = ''
                  this.due_date = ''
                  this.status = ''
                  this.editDocument = false
                  this.personaldocumentid = null 
                  this.$refs.modelform.reset()              
                  store.commit(SET_LOADING, false)
                }
              })
            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });

        }
      }
    },    
    async uploadDocument(){
      if (this.$refs.modelform.validate()) {
        if (this.file != null) {
          var formData = new FormData(document.getElementById("modelform"));
          formData.set("file", this.file)
          formData.set("user_id", this.user_id)
          formData.set("doc_id", this.doc_id)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)
          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
              await store.dispatch(FETCH_PERSONAL_DOCUMENTS, '?user_id='+this.user_id).then( resp =>{
                if (resp !==undefined && resp.success) {
                  store.commit(SET_SNACKBAR, {status: true, message: 'Document updated successfully'})
                  this.$refs.modelform.reset()
                  this.dialog =false
                  this.doc_id = null
                  this.file=  null
                  this.comment  = null
                  this.due_date = null
                  this.status = null
                  this.editDocument = false
                  this.personaldocumentid = null                
                  store.commit(SET_LOADING, false)
                }
              })
            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });

        }
      }
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(ADD_USER, {
            email: this.email,
            name: this.name,
            address: this.address,
            phone_no: this.phone_no,
            salutation: this.salutation,
          })
          .then(resp => {
            if (resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'User created successfully'})
              this.$router.push({ name: "users" });
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(UPDATE_USER, {
            email: this.email,
            name: this.name,
            address: this.address,
            phone_no: this.phone_no,
            salutation: this.salutation,
            user_id: this.user_id,
            status: this.individualuser.status,        
            _method: "put"
          })
          .then(resp => {
            if (resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'User updated successfully'})
              this.$router.push({ name: "users" });
            }
            else{
              store.commit(SET_LOADING, false)
            }

          });
      }
    }
  }
};
</script>